export const appPages = [
  "exam",
  "weekly",
  "monthly",
  "dashboard",
  "daily-agent-comparison",
  "tmall",
  "kuaishou",
  "pdd",
  "douyin",
  "experience",
  "experience-douyin",
  "experience-kuaishou",
  "product",
  "knowledge",
  "quality",
  "reviews",
  "product-insights",
  "invoice",
  "automation",
  "bills",
  "erp",
  "patrol",
] as const;

export type AppPage = (typeof appPages)[number];

export function isAppPage(value: string): value is AppPage {
  return appPages.includes(value as AppPage);
}
